export default "__VITE_ASSET__Dbs_0$5i__"